import { authRoles } from 'app/auth';
import UzenetTable from './table/UzenetTable';
import UzenetEditForm from './editform/UzenetEditForm';

export default [
	{
		path: '/uzenet/edit/:id',
		component: UzenetEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/uzenet/:sessionNameParam?',
		component: UzenetTable,
		auth: authRoles.userAccount
	}
];
